

import { OlympiadExam } from "../schoolPrograms/olympiadExam/OlympiadExam";
import { Inistitution } from "./institution";

export const SchoolOlympiadExamComponent = () => {

    return (<>
        <Inistitution>
            <OlympiadExam isAddFilesVisible={false} isDeleteFilesVisible={false} />

        </Inistitution>

    </>);
}